import {
  Resource,
  List,
  Datagrid,
  BulkDeleteButton,
  TextField,
  Edit,
  SimpleForm,
  TextInput,
  Create,
  FunctionField,
} from "react-admin";
import { CrudPermissions } from "../../auth/crud-permissions";
import PhoneIcon from "@mui/icons-material/Phone";
import { PaidSourceInput } from "./paid-source-input";
import { getPaidSourceName } from "./paid-source-name";
import { TopHelpInfoText } from "../../help/top-help-info-text";

export const TrackedCallResource = (perms: CrudPermissions) => {
  return (
    <Resource
      name="tracked-call"
      key={"tracked-call"}
      options={{
        label: "Tracked Calls",
      }}
      list={TrackedCallList(perms)}
      edit={perms.update ? TrackedCallEdit : undefined}
      create={perms.create ? TrackedCallCreate : undefined}
      icon={PhoneIcon}
    />
  );
};

export const TrackedCallList = (perms: CrudPermissions) => {
  return (
    <>
      <TopHelpInfoText text="Map phone numbers to breakdowns for call tracking and conversion attribution." />
      <List>
        <Datagrid
          rowClick={perms.update ? "show" : false}
          bulkActionButtons={perms.delete ? <BulkDeleteButton /> : false}
        >
          <FunctionField
            label="Breakdown"
            // eslint-disable-next-line
            render={(record) => getPaidSourceName(record.paidSource)}
          />
          <TextField source="destinationPhone" label="Destination Phone" />
          <TextField
            source="destinationPhoneNormalized"
            label="Destination Phone Normalized"
          />
        </Datagrid>
      </List>
    </>
  );
};

export const TrackedCallEdit = () => {
  return (
    <Edit redirect="list">
      <SimpleForm>
        <PaidSourceInput />
        <TextInput
          source="destinationPhone"
          label="Destination Phone"
          fullWidth
        />
        <TextInput
          source="destinationPhoneNormalized"
          label="Destination Phone Normalized (E164)"
          fullWidth
          disabled
        />
      </SimpleForm>
    </Edit>
  );
};

export const TrackedCallCreate = () => {
  return (
    <Create
      redirect="list"
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
      transform={(data) => ({
        ...data,
        // Normalized version will be set by backend.
        // eslint-disable-next-line
        destinationPhoneNormalized: data.destinationPhone,
      })}
    >
      <SimpleForm>
        <PaidSourceInput />
        <TextInput
          source="destinationPhone"
          label="Destination Phone"
          fullWidth
        />
      </SimpleForm>
    </Create>
  );
};
